define('collections/calendar/nutrition/food-favorites',[
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/api',
    // super class
    'collections/calendar/nutrition/foods',
    // models
    'models/calendar/nutrition/food-favorite'
], function(
    // libs
    _, Backbone, Mustache, U,
    // services
    API,
    // super class
    CFoods,
    // model
    MFoodFavorite
) {

    var CFoodFavorites = CFoods.extend({
        model: MFoodFavorite,
        url: function() {
            var options = this.options,
                url = Mustache.render("nutrition/favorites/{{#types}}{{.}}/{{/types}}{{#full}}?food=full{{/full}}", {
                    types: (options.types || []).join('+'),
                    full: options.full
                });
            return API.url(url);
        },

        initialize: function(models, options) {
            CFoodFavorites.__super__.initialize.apply(this, [models, options]);
        },

        getFood: function(id) {
            return this.findWhere({ foodId: id });
        },
    });

    return CFoodFavorites;
});

